import styled from 'styled-components';
import { spacing } from 'ui/theme';

export const CaptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
  margin-top: ${spacing.threeQuarter};
`;
